import React from 'react';
import PropTypes from 'prop-types';

import styled from 'styled-components';

import { FormattedMessage } from 'react-intl';

import colors from 'UIKit/Colors';
import { Flex } from 'UIKit/Grid';

import { StyledButtonIcon } from 'UIKit/Form';

import CircleArrowIcon from '@/assets/img/CircleArrowIcon.png';

export const InputStyled = styled.input`
  position: relative;
  width: 100%;
  height: 28px;
  padding: 0.625rem;
  border: 0;
  border-radius: 20px;
  font-size: 12px;
  padding: 0 16px;
  color: #464d69;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  &[type='checkbox'] {
    position: absolute;
    left: -999px;
    opacity: 0;
    box-shadow: none;
  }
  &:focus {
    outline: 0;
  }
  &:checked {
    ~ .label {
      &:before {
        background-color: ${colors.brand['500']};
      }
      &:after {
        opacity: 1;
      }
    }
  }
  &:disabled {
    background-color: white;
    color: #ababab;
  }
  ~ .label {
    position: relative;
    padding-left: 28px;
    cursor: pointer;
    font-size: 14px;
    &:before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      display: block;
      width: 18px;
      height: 18px;
      border-radius: 2px;
      border: 1px solid ${colors.brand['500']};;
      //background-color: ${colors.brand['500']};
    }
    &:after {
      content: '';
      opacity: 0;
      position: absolute;
      top: 3px;
      left: 4px;
      display: block;
      width: 10px;
      height: 6px;
      border-left: 2px solid ${colors.white['0']};
      border-bottom: 2px solid ${colors.white['0']};
      transform: rotate(-45deg);
      transition: opacity 0.15s ease-in-out;
    }
  }
`;

export const Wrap = styled.div`
  background: linear-gradient(
    180deg,
    rgba(41, 10, 89, 0.65) 0%,
    rgba(255, 124, 0, 0.65) 100%
  );
  ${({ disabled }) => (disabled ? 'background: gray;' : '')}
  padding: 1px;
  border-radius: 20px;
  width: 100%;
`;

export const StyledLabel = styled.label`
  width: 100%;
`;
export const Label = styled.div`
  font-size: 13px;
  color: #a3a3a3;
  &:not(:last-child) {
    margin-bottom: 4px;
  }
`;

export const Error = styled.div`
  font-size: 0.875rem;
  color: ${({ warning }) => (warning ? 'orange' : '#f55145')};
  &:not(:first-child) {
    margin-top: 4px;
  }
`;

const RenderCustomField = ({
  input,
  label,
  type,
  meta: { touched, error, warning },
  placeholder,
  disabled,
  autocomplete,
}) => {
  const increment = () => {
    const newValue = input.value + 1;
    input.onChange(newValue);
  };
  const decrement = () => {
    const newValue = input.value - 1;
    input.onChange(newValue);
  };
  return (
    <StyledLabel>
      {type !== 'checkbox' && label && <Label>{label}</Label>}
      <Flex
        alignItems="center"
        justifyContent="space-between"
        flexDirection={['column-reverse', 'row']}
      >
        <Wrap disabled={disabled}>
          <InputStyled
            {...input}
            autoComplete={autocomplete}
            placeholder={placeholder}
            type={type}
            disabled={disabled}
          />
        </Wrap>
        {type === 'number' && (
          <>
            <StyledButtonIcon
              type="button"
              onClick={() => decrement()}
              style={{ marginLeft: '4px' }}
            >
              <img src={CircleArrowIcon} alt="" />
            </StyledButtonIcon>
            <StyledButtonIcon type="button" onClick={() => increment()}>
              <img
                src={CircleArrowIcon}
                alt=""
                style={{ transform: 'rotate(180deg)' }}
              />
            </StyledButtonIcon>
          </>
        )}
      </Flex>
      {type === 'checkbox' && <Label className="label">{label}</Label>}
      {touched &&
        ((error && (
          <Error>
            <FormattedMessage id={error} defaultMessage="" />
          </Error>
        )) ||
          (warning && <Error warning>{warning}</Error>))}
    </StyledLabel>
  );
};

RenderCustomField.propTypes = {
  input: PropTypes.object.isRequired,
  label: PropTypes.string,
  type: PropTypes.string,
  meta: PropTypes.object,
  disabled: PropTypes.bool,
  placeholder: PropTypes.string,
  autocomplete: PropTypes.string,
};

RenderCustomField.defaultProps = {
  disabled: false,
  placeholder: '',
  label: '',
  type: 'text',
  autocomplete: null,
  meta: {},
};

export default RenderCustomField;
